import { render, staticRenderFns } from "./salesPrePayApplyInitListAction.vue?vue&type=template&id=24db504e&scoped=true"
import script from "./salesPrePayApplyInitListAction.vue?vue&type=script&lang=js"
export * from "./salesPrePayApplyInitListAction.vue?vue&type=script&lang=js"
import style0 from "./salesPrePayApplyInitListAction.vue?vue&type=style&index=0&id=24db504e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db504e",
  null
  
)

export default component.exports